<section id="help-section" class="w-lg-50">
  <h1 class="mb-4">
    NESS Help
  </h1>
  <p class="font-size-sm"><span class="fw-bold">NOTE:</span> We strive to provide additional or updated help materials as NESS continues to be enhanced so please be sure to visit this page often.</p>
  <p class="font-size-sm"><span class="fw-bold">IMPORTANT:</span> If you are not within ATF, please contact your CGIC POC to request a copy of any of the below help items.</p>
  <div>
    <h2 class="text-uppercase bg-active text-white text-center fw-bold">Print Publication</h2>
    <ul class="list-unstyled px-3">
      <li class="mt-1" *ngIf="!isSLUser">
        <button role="link" class="btn btn-link fs-4" (click)="OnDownloadClick('self-registration')"><i aria-hidden="true" class="fas fa-file-pdf me-2"></i>ATF NESS Access Self-Registration Guide</button>
      </li>
      <li class="mt-1" *ngIf="!isSLUser">
        <button role="link" class="btn btn-link fs-4" (click)="OnDownloadClick('reference-guide')"><i aria-hidden="true" class="fas fa-file-pdf me-2"></i>NESS Reference Guide - ATF Users</button>
      </li>
      <li class="mt-1">
        <button role="link" class="btn btn-link fs-4" (click)="OnDownloadClick('reference-guide-SL')"><i aria-hidden="true" class="fas fa-file-pdf me-2"></i>NESS Reference Guide - State &amp; Local Users</button>
      </li>
      <li class="mt-1" *ngIf="!isSLUser">
        <button role="link" class="btn btn-link fs-4" (click)="OnDownloadClick('admin-guide')"><i aria-hidden="true" class="fas fa-file-pdf me-2"></i>ATF App Admin Guide</button>
      </li>
      <li class="mt-1" *ngIf="isSLUser">
        <button role="link" class="btn btn-link fs-4" (click)="OnDownloadClick('admin-guide-SL')"><i aria-hidden="true" class="fas fa-file-pdf me-2"></i>S&L App Admin Guide</button>
      </li>
      <li class="mt-1" *ngIf="!isSLUser">
        <button role="link" class="btn btn-link fs-4" (click)="OnDownloadClick('fd-leadership')"><i aria-hidden="true" class="fas fa-file-pdf me-2"></i>ATF Field Division Leadership Guide</button>
      </li>
      <li class="mt-1" *ngIf="!isSLUser">
        <button role="link" class="btn btn-link fs-4" (click)="OnDownloadClick('cgic-supervisor')"><i aria-hidden="true" class="fas fa-file-pdf me-2"></i>ATF CGIC Supervisor Guide</button>
      </li>
      <li class="mt-1">
        <button role="link" class="btn btn-link fs-4" (click)="OnDownloadClick('mou-process')"><i aria-hidden="true" class="fas fa-file-pdf me-2"></i>State & Local MOU Process</button>
      </li>
      <li class="mt-1">
        <button role="link" class="btn btn-link fs-4" (click)="OnDownloadClick('state-local-access')"><i aria-hidden="true" class="fas fa-file-pdf me-2"></i>NESS Flyer State & Local Access</button>
      </li>
      <li class="mt-1">
        <button role="link" class="btn btn-link fs-4" (click)="OnDownloadClick('clear-browser-cache')"><i aria-hidden="true" class="fas fa-file-pdf me-2"></i>Clear Browser Cache Instructions</button>
      </li>
      <li class="mt-1" *ngIf="isSLUser">
        <button role="link" class="btn btn-link fs-4" (click)="OnDownloadClick('alerts-SL')"><i aria-hidden="true" class="fas fa-file-pdf me-2"></i>State and Local Alerts Flyer</button>
      </li>
      <li class="mt-1" *ngIf="!isSLUser">
        <button role="link" class="btn btn-link fs-4" (click)="OnDownloadClick('atf-ness-chrome-firefox')"><i aria-hidden="true" class="fas fa-file-pdf me-2"></i>ATF NESS Chrome & Firefox Browser Exceptions</button>
      </li>
      <li class="mt-1" *ngIf="!isSLUser">
        <button role="link" class="btn btn-link fs-4" (click)="OnDownloadClick('ness-and-nibin')"><i aria-hidden="true" class="fas fa-file-pdf me-2"></i>NESS & NIBIN Guide</button>
      </li>
    </ul>
    <h2 class="text-uppercase bg-primary-md text-white text-center fw-bold">Step-Out files</h2>
    <ul class="list-unstyled px-3">
      <li class="mt-1">
        <button role="link" class="btn btn-link fs-4" (click)="OnDownloadClick('so-spec-guide')"><i aria-hidden="true" class="fas fa-file-pdf me-2"></i>Step-Out Spec Guide</button>
      </li>
      <li class="mt-1">
        <button role="link" class="btn btn-link fs-4" (click)="OnDownloadClick('so-cfs')"><i aria-hidden="true" class="fas fa-file-pdf me-2"></i>Step-Out Formatting Specification (cfs) file</button>
      </li>
      <li class="mt-1">
        <button role="link" class="btn btn-link fs-4" (click)="OnDownloadClick('so-spec-ximp')"><i aria-hidden="true" class="fas fa-file-pdf me-2"></i>Step-Out ximp file</button>
      </li>
      <li class="mt-1">
        <button role="link" class="btn btn-link fs-4" (click)="OnDownloadClick('so-ant')"><i aria-hidden="true" class="fas fa-file-pdf me-2"></i>Step-Out Ant file</button>
      </li>
    </ul>
  </div>
</section>
